document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pp2-ritual-goals').forEach(function (goalsBar) {
    var section = goalsBar.closest('section');
    var recsWrap = section.querySelector('.pp2-ritual-recs');
    var buttons = goalsBar.querySelectorAll('.pp2-ritual-goal-btn');
    var cards = recsWrap.querySelectorAll('.pp2-ritual-rec');

    function activeStyle(btn) {
      btn.style.background = 'var(--pp2-navy)';
      btn.style.color = '#fff';
      btn.style.border = 'none';
    }
    function inactiveStyle(btn) {
      btn.style.background = 'var(--pp2-cream)';
      btn.style.color = 'var(--pp2-navy)';
      btn.style.border = '1.5px solid var(--pp2-btn-border)';
    }

    function setGoal(goal) {
      buttons.forEach(function (btn) {
        var isActive = btn.dataset.goal === goal;
        btn.classList.toggle('is-active', isActive);
        isActive ? activeStyle(btn) : inactiveStyle(btn);
      });
      cards.forEach(function (card) {
        var goals = (card.dataset.goals || '').split(',').map(function (g) { return g.trim(); });
        card.style.display = goals.indexOf(goal) !== -1 ? '' : 'none';
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { setGoal(btn.dataset.goal); });
    });

    if (buttons.length) setGoal(buttons[0].dataset.goal);
  });
});
